// extracted by mini-css-extract-plugin
export default {"itemRow":"invoice_itemRow__ivD4Q","removeIcon":"invoice_removeIcon__bQIy7","fileLocation":"invoice_fileLocation__vEzl0"};